export default __webpack_public_path__ + "static/media/no_background_2.08873778.png";